import React from 'react'
import { Layout, Typography, Space, Divider } from 'antd'
import { PhoneOutlined } from '@ant-design/icons'
import { FaWhatsapp, FaInstagram } from 'react-icons/fa'

const { Footer } = Layout
const { Text, Title } = Typography

export default function AppFooter () {
  return (
    <Footer
      style={{
        backgroundColor: '#001529',
        color: '#fff',
        textAlign: 'center',
        padding: '40px 20px'
      }}
    >
      {/* Título e slogan */}
      <Title level={4} style={{ color: '#fff', marginBottom: 8 }}>
        Marcilene Paz Imóveis
      </Title>
      <Text style={{ color: '#ccc', fontSize: 14 }}>
        Realizando sonhos, com transparência e confiança.
      </Text>

      <Divider style={{ backgroundColor: '#444' }} />

      {/* Seção de contato */}
      <Space
        direction="vertical"
        size="small"
        style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}
      >
        <Text strong style={{ color: '#fff' }}>Anuncie seu imóvel conosco</Text>
        <a
          href="tel:+5522999666419"
          style={{ color: '#fff', fontSize: 16 }}
        >
          <PhoneOutlined /> (22) 99966-6419
        </a>
      </Space>

      {/* Consultora */}
      <Space
        direction="vertical"
        size="small"
        style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}
      >
        <Text strong style={{ color: '#fff' }}>Consultora:</Text>
        <Text style={{ color: '#fff' }}>Marcilene Paz | CRECI: RJ01063290</Text>
      </Space>

      {/* Redes sociais */}
      <Space size="large">
        <a
          href="https://wa.me/5522999666419"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#25D366', fontSize: 22 }}
        >
          <FaWhatsapp />
        </a>
        <a
          href="https://instagram.com/seuPerfil"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#E1306C', fontSize: 22 }}
        >
          <FaInstagram />
        </a>
      </Space>

      <Divider style={{ backgroundColor: '#444' }} />

      {/* Direitos reservados */}
      <Text style={{ color: '#aaa', fontSize: 12 }}>
        © {new Date().getFullYear()} Marcilene Paz Imóveis. Todos os direitos reservados.
      </Text>
    </Footer>
  )
}
